import { useService } from 'bpmn-js-properties-panel';
import { html } from 'htm/preact';
import { useState } from '@bpmn-io/properties-panel/preact/hooks';


export default function VariableChangesEntry(element) {
	return [
		{
			id: 'variableChanges',
			element,
			component: VariableChangesBox
		}
	];
}


function VariableChangesBox(props) {
	const { element } = props;

	const modeling = useService('modeling');


	const loadChanges = () => {
		try {
			const value = element.businessObject?.variableChanges;

			if (!value)
				return [];

			return JSON.parse(value);
		}
		catch (e) {
			console.error('Invalid variableChanges JSON', e);
			return [];
		}
	};


	const [changes, setChanges] = useState(loadChanges);


	const saveChanges = newChanges => {
		setChanges(newChanges);

		modeling.updateProperties(element, {
			variableChanges: JSON.stringify(newChanges)
		});
	};


	const addChange = () => {
		console.log('Add variable');

		saveChanges([
			...changes,
			{
				variable: '',
				operation: 'add',
				value: '',
				unit: ''
			}
		]);
	};


	const updateChange = (index, field, value) => {
		const newChanges = changes.map((change, i) => {

			if (i !== index)
				return change;

			return {
				...change,
				[field]: value
			};
		});

		saveChanges(newChanges);
	};


	const removeChange = index => {
		saveChanges(
			changes.filter((_, i) => i !== index)
		);
	};


	return html`
		<div style="padding:8px 12px;">

			${changes.map((change, index) => html`

				<div
					key=${index}
					style="
						display:grid;
						grid-template-columns:80px 50px 80px 35px ;
						gap:4px;
						margin-bottom:6px;
						align-items:center;
					"
				>

					<input
						type="text"
						placeholder="Variable"
						style="min-width:0; width:100%; box-sizing:border-box;"
						value=${change.variable}
						onInput=${e =>
							updateChange(
								index,
								'variable',
								e.target.value
							)
						}
					/>

					<select
						value=${change.operation}
						style="
								min-width:0;
								width:100%;
								height:30px;
								box-sizing:border-box;
							"
						onChange=${e =>
							updateChange(
								index,
								'operation',
								e.target.value
							)
						}
					>
						<option value="set">Set</option>
						<option value="add">Add</option>
						<option value="subtract">Subtract</option>
					</select>

					<input
						type="text"
						placeholder="Value"
						value=${change.value}
						onInput=${e =>
							updateChange(
								index,
								'value',
								e.target.value
							)
						}
					/>


					<button
						type="button"
						onClick=${() => removeChange(index)}
					>
						×
					</button>

				</div>

			`)}

			<button
				type="button"
				class="bio-properties-panel-button"
				onClick=${addChange}
			>
				+ Add Variable
			</button>

		</div>
	`;
}